import { BaseUser } from '@lib/core/model';
import { Uuid } from '@lib/core/type';
import { WorkerItem } from '@proget-shared/grid/grid-actions';
import { SelectableItem } from '@proget-shared/grid/selection';
import { TableRow } from '@proget-shared/grid/table';

import { Certificate } from './certificate';

export class ExternalCertificate implements WorkerItem, SelectableItem, TableRow {
  constructor(
    public readonly id: Uuid,
    public readonly purpose: string,
    public readonly encryptionCertificate: Certificate | null,
    public readonly signingCertificate: Certificate | null,
    public readonly user: BaseUser,
    public readonly modifiedBy: BaseUser
  ) {}

  getId(): Uuid {
    return this.id;
  }

  getDisplayName(): string {
    return this.purpose;
  }

  getSelectionId(): Uuid {
    return this.id;
  }

  isExpandable(): boolean {
    return !!this.encryptionCertificate || !!this.signingCertificate;
  }

  public get valid(): boolean {
    return (this.encryptionCertificate?.valid ?? true) && (this.signingCertificate?.valid ?? true);
  }
}
